import { Component, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OtpUtil, Time } from '@ridango/components';
import { Moment } from 'moment-timezone';
import moment from 'moment/moment';

@Component({
    selector: 'rwidget-schedule',
    templateUrl: './schedule.component.html',
    styleUrls: ['./schedule.component.scss']
})
export class ScheduleComponent implements OnChanges {
    @Input() times: Time[] = [];
    @Input() highlightNextUpcomingStop = true;

    scheduleRows: Moment[][] = [];
    private rowIndexWithNextUpcomingDeparture = -1;
    private nextDepartureTimeIndexInRow = -1;

    constructor(@Inject('ENV') public env: any) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.times) {
            this.setScheduleData();
        }
    }

    isRowWithNextUpcomingDeparture(rowIndex: number): boolean {
        return rowIndex === this.rowIndexWithNextUpcomingDeparture;
    }

    isNextDeparture(rowIndex: number, timeIndexInRow: number) {
        return this.isRowWithNextUpcomingDeparture(rowIndex) && timeIndexInRow === this.nextDepartureTimeIndexInRow;
    }

    addBorderBottom(rowIndex: number): boolean {
        const isRowWithNextUpcomingDeparture = this.isRowWithNextUpcomingDeparture(rowIndex);
        const isRowBeforeWithNextUpcomingDeparture = rowIndex + 1 === this.rowIndexWithNextUpcomingDeparture;
        return !isRowWithNextUpcomingDeparture && !isRowBeforeWithNextUpcomingDeparture;
    }

    private setScheduleData() {
        this.resetData();
        const newRows = this.createRows();
        this.setNextUpcomingDepartureIndexes(newRows);
        this.scheduleRows = newRows;
    }

    private resetData() {
        this.scheduleRows = [];
        this.rowIndexWithNextUpcomingDeparture = -1;
        this.nextDepartureTimeIndexInRow = -1;
    }

    private createRows(): Moment[][] {
        const hourRows = [];
        let row: Moment[] = [];
        (this.times ?? [])
            .filter((time) => time.scheduledDeparture != null)
            .forEach((time) => {
                const departureTime = OtpUtil.getScheduledDepartureMoment(time);
                if (row.length === 0 || row[0].isSame(departureTime, 'hours')) {
                    row.push(departureTime);
                } else {
                    hourRows.push([...row]);
                    row = [departureTime];
                }
            });
        if (row.length !== 0) {
            hourRows.push([...row]);
        }
        return hourRows;
    }

    private setNextUpcomingDepartureIndexes(newRows: Moment[][]) {
        if (!this.highlightNextUpcomingStop) {
            return;
        }
        let rowIndex = -1;
        let itemIndex = -1;
        for (let i = 0; i < newRows.length; i++) {
            for (let j = 0; j < newRows[i].length; j++) {
                if (newRows[i][j].isAfter(moment())) {
                    rowIndex = i;
                    itemIndex = j;
                    break;
                }
            }
            if (rowIndex >= 0) {
                break;
            }
        }
        this.rowIndexWithNextUpcomingDeparture = rowIndex;
        this.nextDepartureTimeIndexInRow = itemIndex;
    }
}
